import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	restrictedTooltip: {
		id: 'search-page.results.restricted-result-tooltip',
		defaultMessage: 'Only visible to specific people',
		description:
			'The text displayed in the tooltip when the user hovers over the restricted label.',
	},
	privateTooltip: {
		id: 'search-page.results.private-result-tooltip',
		defaultMessage: 'Only visible to you',
		description: 'The text displayed in the tooltip when the user hovers over the private label.',
	},
});
